// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const { getContentFormContainer } =
  require("../../manage/methods/ContentFormUtils").default
const { LISTED } = require("./ManageEventConfig").default

export const listed = {
  icon: "calendar",
  title: "Add event instructions",
  prompt: "For a class, meeting, or online live stream ",
  form: getContentFormContainer(LISTED)
}
